import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import MainLayout from "./pages/MainLayout";
import { BookPage } from "./pages/BookPage";
import EditorInChiefPage from "./pages/EditorInChiefPage";
import EditorialBoardPage from "./pages/Board/EditorialBoardPage";
import WhyRdPage from "./pages/Board/WhyRdPage";
import PublicationsCriteriaPage from "./pages/Board/PublicationsCriteriaPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="editor-in-chief" element={<EditorInChiefPage />} />
          <Route>
            <Route
              path="board/editorial-board"
              element={<EditorialBoardPage />}
            />
          </Route>
          <Route path="board/why-rd" element={<WhyRdPage />} />
          <Route path="board/why-rd" element={<WhyRdPage />} />
          <Route
            path="board/publication-criteria"
            element={<PublicationsCriteriaPage />}
          />
        </Route>
        <Route path="book" element={<BookPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
